import { render, staticRenderFns } from "./uploadImg-model.vue?vue&type=template&id=a9f9f25a&scoped=true&"
import script from "./uploadImg-model.vue?vue&type=script&lang=js&"
export * from "./uploadImg-model.vue?vue&type=script&lang=js&"
import style0 from "./uploadImg-model.vue?vue&type=style&index=0&id=a9f9f25a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f9f25a",
  null
  
)

export default component.exports